/* vc-service-leiste.js: Skript der Section sections/vc-service-leiste.liquid (VC Sections von VersagerClo).
   Liegt als eigene Datei vor, damit es nur auf Seiten lädt, auf denen die Section steht. Läuft einmal pro Seite,
   auch wenn die Section mehrmals vorkommt. Wartet auf die VC-Grundlage (vc-basis), falls sie noch fehlt. */
(function () {
  var geladen = window.VCJS = window.VCJS || {};
  if (geladen['vc-service-leiste']) return;
  geladen['vc-service-leiste'] = true;
  var los = function () {
  if (!customElements.get('vc-service-leiste')) {
    customElements.define('vc-service-leiste', class extends HTMLElement {
      connectedCallback() {
        if (this._vcAn) { this.anmelden(); return; }
        this._vcAn = true;
        var el = this;
        // Punkt mit Tab: steht VC Versand & Rückgabe auf der Seite, dort den Tab öffnen. Sonst gilt der eigene Link.
        this.addEventListener('click', function (e) {
          var a = e.target.closest('a.vc-sl__ding[data-tab]');
          if (!a || !a.hasAttribute('href') || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var d = { tab: a.dataset.tab, ok: false, von: a };
          document.dispatchEvent(new CustomEvent('vc:versand-oeffnen', { detail: d }));
          if (d.ok) e.preventDefault();
        });
        this._spaeter = function () { setTimeout(function () { el.pruefen(); }, 80); };
        this.anmelden();
      }
      anmelden() {
        document.addEventListener('shopify:section:load', this._spaeter);
        document.addEventListener('shopify:section:unload', this._spaeter);
        this.pruefen();
      }
      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this._spaeter);
        document.removeEventListener('shopify:section:unload', this._spaeter);
      }
      /** Punkte ohne eigenen Link zeigen nur dann auf #vc-versand, wenn es die Section auf der Seite gibt. Sonst kein toter Link. */
      pruefen() {
        var da = !!document.getElementById('vc-versand');
        this.querySelectorAll('a.vc-sl__ding[data-tab]').forEach(function (a) {
          if (a.hasAttribute('data-eigen')) return;
          if (da) a.setAttribute('href', '#vc-versand');
          else a.removeAttribute('href');
        });
      }
    });
  }
  };
  if (window.VC && window.VC.melden) los(); else document.addEventListener('DOMContentLoaded', los);
})();
